var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 488.8,
    height: 191.002,
    viewBox: "0 0 488.8 191.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c58300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.47,
    y1: 0.5,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb9c00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sd_logo",
    transform: "translate(-94 -71.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M185.19,36.7H0L19.023,0H185.19V36.7Z",
    transform: "translate(94 225.985)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M182,36.7H0L18.7,0H182V36.7Z",
    transform: "translate(386.397 108.836) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M169.027,36.7H0L21.191,0H169.027V36.7Z",
    transform: "translate(413.773 72.04)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M258.537,36.7H0L21.191,0H258.537V36.7Z",
    transform: "translate(324.264 225.985)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M297.751,190.955H263.627v-.228h-2.6V0h36.722V190.955ZM0,178.973V154.28H14.273L.014,178.949Z",
    transform: "translate(285.049 72.04)",
    fill: "#ffb622"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(468.449 140.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 14.919,
    height: 14.919,
    rx: 2,
    transform: "translate(22.378)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 14.919,
    height: 14.919,
    rx: 2,
    transform: "translate(22.378 44.756)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 14.919,
    height: 14.919,
    rx: 2,
    transform: "translate(0 22.378)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 14.919,
    height: 14.919,
    rx: 2,
    transform: "translate(44.756 22.378)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(386.397 140.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-2",
    "data-name": "Rectangle 13",
    width: 14.919,
    height: 59.674,
    rx: 2,
    transform: "translate(22.378)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-2",
    "data-name": "Rectangle 11",
    width: 59.674,
    height: 14.919,
    rx: 2,
    transform: "translate(0 22.378)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-2",
    "data-name": "Rectangle 12",
    width: 37.296,
    height: 14.919,
    rx: 2,
    transform: "translate(22.378 22.378)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-127.4,262.719-223,107.006l21.072-35.012,95.153,154.244Z",
    transform: "translate(406.508 0)",
    fill: "#ffb622"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdLogo);
export default __webpack_public_path__ + "static/media/sd_logo.2beaf5bb69491cb9a698cbe2a895a159.svg";
export { ForwardRef as ReactComponent };